const initialState = {
    introduccion: [],
    seccion1: [],
    seccion2: [],
    seccion3: [],
    enlaces: [],
    preguntas: []
}
const CONTENIDO_LOGOUT = '[CONTENIDO LG] CONTENIDO LOGOUT'
const CONTENIDO_LOADED = '[CONTENIDO LD] CONTENIDO LOADED'
const CONTENIDO_UPDATE_DESCRIPTION = '[CONTENIDO LD] CONTENIDO UPDATE DESCRIPTION'
const CONTENIDO_UPDATE_IMAGEN = '[CONTENIDO LD] CONTENIDO UPDATE IMAGEN'


const CONTENIDO_UPDATE_TITULO_SEC_UNO = '[C UP TSU] CONTENIDO UPDATE TITULO SEC 1'
const CONTENIDO_UPDATE_TITULO_SEC_DOS = '[C UP TSU] CONTENIDO UPDATE TITULO SEC 2'
const CONTENIDO_UPDATE_TITULO_SEC_TRES = '[C UP TSU] CONTENIDO UPDATE TITULO SEC 3'


const CONTENIDO_UPDATE_VIDEO_SEC_UNO = '[C UP TSU] CONTENIDO UPDATE VIDEO SEC 1'
const CONTENIDO_UPDATE_VIDEO_SEC_DOS = '[C UP TSU] CONTENIDO UPDATE VIDEO SEC 2'
const CONTENIDO_UPDATE_VIDEO_SEC_TRES = '[C UP TSU] CONTENIDO UPDATE VIDEO SEC 3'

const CONTENIDO_UPDATE_PICTURE_SEC_UNO = '[C UP TSU] CONTENIDO UPDATE PICTURE SEC 1'
const CONTENIDO_UPDATE_PICTURE_SEC_DOS = '[C UP TSU] CONTENIDO UPDATE PICTURE SEC 2'
const CONTENIDO_UPDATE_PICTURE_SEC_TRES = '[C UP TSU] CONTENIDO UPDATE PICTURE SEC 3'

const CONTENIDO_UPDATE_DESCRIPTION_SEC_UNO = '[C UP TSU] CONTENIDO UPDATE DESCRIPTION SEC 1'
const CONTENIDO_UPDATE_DESCRIPTION_SEC_DOS = '[C UP TSU] CONTENIDO UPDATE DESCRIPTION SEC 2'
const CONTENIDO_UPDATE_DESCRIPTION_SEC_TRES = '[C UP TSU] CONTENIDO UPDATE DESCRIPTION SEC 3'


const CONTENIDO_UPDATE_ENLACE_SEC_UNO = '[C UP TSU] CONTENIDO UPDATE ENLACE SEC 1'
const CONTENIDO_UPDATE_ENLACE_SEC_DOS = '[C UP TSU] CONTENIDO UPDATE ENLACE SEC 2'
const CONTENIDO_UPDATE_ENLACE_SEC_TRES = '[C UP TSU] CONTENIDO UPDATE ENLACE SEC 3'

const CONTENIDO_UPDATE_ENLACE_UNO = '[C UP EU] CONTENIDO UPDATE ENLACE 1'
const CONTENIDO_UPDATE_ENLACE_DOS = '[C UP EU] CONTENIDO UPDATE ENLACE 2'


const CONTENIDO_UPDATE_TITULO_ENLACE = '[C UP TE] CONTENIDO ENLACE TITULO UPDATE'

const CONTENIDO_DELETE_QUESTION = '[C D Q] CONTENIDO DELETE QUESTION'
const CONTENIDO_ADD_QUESTION = '[C ADD Q] CONTENIDO ADD QUESTION'
const CONTENIDO_UPDATE_QUESTION = '[C U Q] CONTENIDO UPDATE QUESTION'

export const loadContenido = (introduccion, seccion1, seccion2, seccion3, seccion4, seccion5) => ({
    type: CONTENIDO_LOADED,
    payload: {
        introduccion: introduccion,
        seccion1: seccion1,
        seccion2: seccion2,
        seccion3: seccion3,
        enlaces: seccion4,
        preguntas: seccion5
    }
})

export const setIntroDescription = (description) => ({
    type: CONTENIDO_UPDATE_DESCRIPTION,
    payload:{
        description
    }
})

export const setIntroImagen = (imagen) => ({
    type: CONTENIDO_UPDATE_IMAGEN,
    payload:{
        imagen
    }
})


export const setseccion1Titulo = (title) => ({
    type: CONTENIDO_UPDATE_TITULO_SEC_UNO,
    payload: {title}
})

export const setseccion2Titulo = (title) => ({
    type: CONTENIDO_UPDATE_TITULO_SEC_DOS,
    payload: {title}
})

export const setseccion3Titulo = (title) => ({
    type: CONTENIDO_UPDATE_TITULO_SEC_TRES,
    payload: {title}
})



export const setseccion1Video = (video) => ({
    type: CONTENIDO_UPDATE_VIDEO_SEC_UNO,
    payload: {video}
})

export const setseccion2Video = (video) => ({
    type: CONTENIDO_UPDATE_VIDEO_SEC_DOS,
    payload: {video}
})

export const setseccion3Video = (video) => ({
    type: CONTENIDO_UPDATE_VIDEO_SEC_TRES,
    payload: {video}
})


export const setseccion1Imagen = (picture) => ({
    type: CONTENIDO_UPDATE_PICTURE_SEC_UNO,
    payload: {picture}
})

export const setseccion2Imagen = (picture) => ({
    type: CONTENIDO_UPDATE_PICTURE_SEC_DOS,
    payload: {picture}
})

export const setseccion3Imagen = (picture) => ({
    type: CONTENIDO_UPDATE_PICTURE_SEC_TRES,
    payload: {picture}
})


export const setseccion1Description = (description) => ({
    type: CONTENIDO_UPDATE_DESCRIPTION_SEC_UNO,
    payload: {description}
})

export const setseccion2Description = (description) => ({
    type: CONTENIDO_UPDATE_DESCRIPTION_SEC_DOS,
    payload: {description}
})

export const setseccion3Description = (description) => ({
    type: CONTENIDO_UPDATE_DESCRIPTION_SEC_TRES,
    payload: {description}
})


export const setseccion1Enlace = (link) => ({
    type: CONTENIDO_UPDATE_ENLACE_SEC_UNO,
    payload: {link}
})

export const setseccion2Enlace = (link) => ({
    type: CONTENIDO_UPDATE_ENLACE_SEC_DOS,
    payload: {link}
})

export const setseccion3Enlace = (link) => ({
    type: CONTENIDO_UPDATE_ENLACE_SEC_TRES,
    payload: {link}
})


export const setEnlace_Uno = (link1,namelink1) => ({
    type: CONTENIDO_UPDATE_ENLACE_UNO,
    payload: {
        link1,namelink1
    }
})

export const setEnlace_Dos = (link2,namelink2) => ({
    type: CONTENIDO_UPDATE_ENLACE_DOS,
    payload: {
        link2,namelink2
    }
})

export const setEnlaceTitle = (title) => ({
    type: CONTENIDO_UPDATE_TITULO_ENLACE,
    payload: {
        title
    }
})

export const delQuestionById = (id) => ({
    type: CONTENIDO_DELETE_QUESTION,
    payload: {id}
})

export const setQuestionById = (id, question) => ({
    type: CONTENIDO_UPDATE_QUESTION,
    payload: {id, question}
})



export const newQuestion = (id, question) => ({
    type: CONTENIDO_ADD_QUESTION,
    payload: {id, question}
})

export const logoutcontenido = () => ({type: CONTENIDO_LOGOUT})

const ContenidoReducer = (state = initialState, action) => {
    switch (action.type) {
        case CONTENIDO_LOADED:
            return{
                introduccion: action.payload.introduccion,
                seccion1: action.payload.seccion1,
                seccion2: action.payload.seccion2,
                seccion3: action.payload.seccion3,
                enlaces: action.payload.enlaces,
                preguntas: action.payload.preguntas
            }
        case CONTENIDO_UPDATE_IMAGEN:
            return {
                ...state,
                introduccion: {
                    ...state.introduccion,
                    picture: action.payload.imagen
                }
            }
        case CONTENIDO_UPDATE_DESCRIPTION:
            return {
                ...state,
                introduccion: {
                    ...state.introduccion,
                    description: action.payload.description
                }
            }
        case CONTENIDO_UPDATE_TITULO_SEC_UNO:
            return {
                ...state, 
                seccion1: {
                    ...state.seccion1,
                    title: action.payload.title
                }
                
            }
        case CONTENIDO_UPDATE_VIDEO_SEC_UNO:
            return {
                ...state, 
                seccion1: {
                    ...state.seccion1,
                    video: action.payload.video
                }
                
            }

        case CONTENIDO_UPDATE_PICTURE_SEC_UNO:
            return {
                ...state,
                seccion1: {
                    ...state.seccion1,
                    picture: action.payload.picture
                }
            }

        case CONTENIDO_UPDATE_DESCRIPTION_SEC_UNO:
            return {
                ...state,
                seccion1: {
                    ...state.seccion1,
                    description: action.payload.description
                }
            }

        case CONTENIDO_UPDATE_ENLACE_SEC_UNO:
            return {
                ...state,
                seccion1: {
                    ...state.seccion1,
                    link: action.payload.link
                }
            }

        case CONTENIDO_UPDATE_TITULO_SEC_DOS:
            return {
                ...state, 
                seccion2: {
                    ...state.seccion2,
                    title: action.payload.title
                }
                
            }
        case CONTENIDO_UPDATE_VIDEO_SEC_DOS:
            return {
                ...state, 
                seccion2: {
                    ...state.seccion2,
                    video: action.payload.video
                }
                
            }

        case CONTENIDO_UPDATE_PICTURE_SEC_DOS:
            return {
                ...state,
                seccion2: {
                    ...state.seccion2,
                    picture: action.payload.picture
                }
            }

        case CONTENIDO_UPDATE_DESCRIPTION_SEC_DOS:
            return {
                ...state,
                seccion2: {
                    ...state.seccion2,
                    description: action.payload.description
                }
            }

        case CONTENIDO_UPDATE_ENLACE_SEC_DOS:
            return {
                ...state,
                seccion2: {
                    ...state.seccion2,
                    link: action.payload.link
                }
            }

        case CONTENIDO_UPDATE_TITULO_SEC_TRES:
            return {
                ...state, 
                seccion3: {
                    ...state.seccion3,
                    title: action.payload.title
                }
                
            }
        case CONTENIDO_UPDATE_VIDEO_SEC_TRES:
            return {
                ...state, 
                seccion3: {
                    ...state.seccion3,
                    video: action.payload.video
                }
                
            }

        case CONTENIDO_UPDATE_PICTURE_SEC_TRES:
            return {
                ...state,
                seccion3: {
                    ...state.seccion3,
                    picture: action.payload.picture
                }
            }

        case CONTENIDO_UPDATE_DESCRIPTION_SEC_TRES:
            return {
                ...state,
                seccion3: {
                    ...state.seccion3,
                    description: action.payload.description
                }
            }

        case CONTENIDO_UPDATE_ENLACE_SEC_TRES:
            return {
                ...state,
                seccion3: {
                    ...state.seccion3,
                    link: action.payload.link
                }
            }

        case CONTENIDO_UPDATE_TITULO_ENLACE:
            return {
                ...state,
                enlaces: {
                    ...state.enlaces,
                    title: action.payload.title
                }
            }
        
        case CONTENIDO_UPDATE_ENLACE_UNO:
            return {
                ...state,
                enlaces: {
                    ...state.enlaces,
                    link1: action.payload.link1,
                    namelink1: action.payload.namelink1
                }
            }
        case CONTENIDO_UPDATE_ENLACE_DOS:
            return {
                ...state,
                enlaces: {
                    ...state.enlaces,
                    link2: action.payload.link2,
                    namelink2: action.payload.namelink2
                }
            }
        case CONTENIDO_ADD_QUESTION:
            return {
                ...state,
                preguntas: [...state.preguntas, action.payload]
            }
        case CONTENIDO_DELETE_QUESTION:
            return {
                ...state,
                preguntas: state.preguntas.filter(question => question.id !== action.payload.id)
                
            }
        case CONTENIDO_UPDATE_QUESTION:
            return {
                ...state,
                preguntas: state.preguntas.map(
                    e => (e.id === action.payload.id) ? action.payload : e
                )
            }
        
        case CONTENIDO_LOGOUT:
            return state = initialState

        default:
            return state;
    }
}

export default ContenidoReducer;